import { render } from "./BullletEnd.vue?vue&type=template&id=87cd886e"
import script from "./BullletEnd.vue?vue&type=script&lang=js"
export * from "./BullletEnd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__